import type { ReactNode } from "react";

import type { CmsPageRenderProps } from "./renderProps";
import { themeStyle } from "./theme";

const CLARO_HOME_URL = "https://claroadvisors.com/";
const CLARO_LOGO_URL = "https://claroadvisors.com/images/logo-ca.svg";
const CLARO_FOOTER_LOGO_URL = "https://claroadvisors.com/images/logo-ca-short.svg";

interface CmsPageShellProps {
  page: CmsPageRenderProps;
  mainClassName?: string;
  children: ReactNode;
}

export function CmsPageShell({ page, mainClassName, children }: CmsPageShellProps) {
  return (
    <div className="cms-page" data-cms-page-slug={page.slug} style={themeStyle(page.theme)}>
      <CmsMicrositeHeader />
      <main className={mainClassName}>{children}</main>
      <CmsMicrositeFooter />
    </div>
  );
}

function CmsMicrositeHeader() {
  return (
    <header className="cms-site-header">
      <div className="cms-wrap cms-site-header__inner">
        <a className="cms-site-header__logo-link" href={CLARO_HOME_URL} aria-label="Claro Advisors home">
          <img src={CLARO_LOGO_URL} alt="Claro Advisors" className="cms-site-header__logo" />
        </a>
      </div>
    </header>
  );
}

function CmsMicrositeFooter() {
  return (
    <footer className="cms-site-footer">
      <div className="cms-wrap cms-site-footer__inner">
        <a className="cms-site-footer__logo-link" href={CLARO_HOME_URL} aria-label="Claro Advisors home">
          <img src={CLARO_FOOTER_LOGO_URL} alt="Claro Advisors" className="cms-site-footer__logo" />
        </a>
      </div>
    </footer>
  );
}
